import React, { useEffect, useState } from 'react'


import { deleteUser, login, filterBannedUsers } from '../utils/Network'
import { Link } from 'react-router-dom';
import { getAge, getUser, isNumber } from '../utils';
import CityName from '../components/CityName';
import SelectCourses from '../components/SelectCourses';
import SelectTalent from '../components/SelectTalent';
import SelectGender from '../components/SelectGender';
import SelectYear from '../components/SelectYear';
import SelectMonth from '../components/SelectMonth';
import SelectCountries from '../components/SelectCountries';
import SelectCities from '../components/SelectCities';
import Modal from 'react-modal';
import SelectSize from '../components/SelectSize';
import UserTalentList from '../components/UserTalentList';


export default function BannedContent({ page = 1, urlParams }) {


    const [loading, setLoading] = useState(0);
    const [show_filter, setShowFilter] = useState(false);
    const [show_delete, setShowDelete] = useState(false);

    const [users, setUsers] = useState([]);

    const [count, setCount] = useState(null);
    const [pages, setPages] = useState(null);

    const [filter_course_value, setFilterCourseValue] = useState(null);
    const [filter_talent_value, setFilterTalentValue] = useState(null);
    const [filter_gender_value, setFilterGenderValue] = useState(null);
    const [filter_size_value, setFilterSizeValue] = useState(null);

    const [filter_from_year_value, setFilterFromYearValue] = useState(null);
    const [filter_from_month_value, setFilterFromMonthValue] = useState(null);

    const [filter_to_year_value, setFilterToYearValue] = useState(null);
    const [filter_to_month_value, setFilterToMonthValue] = useState(null);

    const [filter_birth_country_value, setFilterBirthCountryValue] = useState(null);
    const [filter_birth_city_value, setFilterBirthCityValue] = useState(null);
    const [filter_living_country_value, setFilterLivingCountryValue] = useState(null);
    const [filter_living_city_value, setFilterLivingCityValue] = useState(null);


    //Filters
    let filter_first_name = urlParams.get('first_name');
    let filter_last_name = urlParams.get('last_name');
    let filter_gender = urlParams.get('gender');
    let filter_birth_country = urlParams.get('country');
    let filter_birth_city = urlParams.get('city');
    let filter_living_country = urlParams.get('living_country');
    let filter_living_city = urlParams.get('living_city');
    let filter_talent = urlParams.get('talent');
    let filter_course = urlParams.get('course');
    let filter_size = urlParams.get('size') ? urlParams.get('size') : 10;

    let filter_from_year = isNumber(urlParams.get('from_year')) ? urlParams.get('from_year') : null;

    let filter_from_month = urlParams.get('from_month');
    let filter_from_day = urlParams.get('from_day');
    let filter_fbirthdate = "";

    if (filter_from_year) {
        filter_from_month = isNumber(filter_from_month) ? filter_from_month : 1;
        filter_from_day = isNumber(filter_from_day) ? filter_from_day : 1;
        filter_fbirthdate = filter_from_year + "-" + filter_from_month + "-" + filter_from_day;
    }


    let filter_to_year = isNumber(urlParams.get('to_year')) ? urlParams.get('to_year') : null;
    let filter_to_month = urlParams.get('to_month');
    let filter_to_day = urlParams.get('to_day');
    let filter_tbirthdate = "";
    if (filter_to_year) {
        filter_to_month = isNumber(filter_to_month) ? filter_to_month : 1;
        filter_to_day = isNumber(filter_to_day) ? filter_to_day : 1;
        filter_tbirthdate = filter_to_year + "-" + filter_to_month + "-" + filter_to_day;
    }

    //Creating Filter Query

    let filter_query = "";
    var filtered = false;

    if (filter_first_name && filter_first_name.length > 0) {
        filter_query += "&first_name=" + filter_first_name;
        filtered = true;
    }

    if (filter_last_name && filter_last_name.length > 0) {
        filter_query += "&last_name=" + filter_last_name;
        filtered = true;
    }

    if (filter_gender && filter_gender.length > 0) {
        filter_query += "&gender=" + filter_gender;
        filtered = true;
    }

    if (filter_birth_country && filter_birth_country.length > 0) {

        filter_query += "&country=" + filter_birth_country;
        filtered = true;
    }

    if (filter_birth_city && filter_birth_city.length > 0) {
        filter_query += "&city=" + filter_birth_city;
        filtered = true;
    }

    if (filter_living_country && filter_living_country.length > 0) {
        filter_query += "&livingcountry=" + filter_living_country;
        filtered = true;
    }



    if (filter_living_city && filter_living_city.length > 0) {
        filter_query += "&livingcity=" + filter_living_city;
        filtered = true;
    }

    if (filter_fbirthdate && filter_fbirthdate.length > 0) {
        filter_query += "&fbirthdate=" + filter_fbirthdate;
        filtered = true;
    }
    if (filter_tbirthdate && filter_tbirthdate.length > 0) {
        filter_query += "&tbirthdate=" + filter_tbirthdate;
        filtered = true;
    }

    if (filter_talent && isNumber(filter_talent)) {
        filter_query += "&talent=" + filter_talent;
        filtered = true;
    }

    if (filter_course && isNumber(filter_course)) {
        filter_query += "&course=" + filter_course;
        filtered = true;
    }

    if (filter_size && isNumber(filter_size)) {
        filter_query += "&size=" + filter_size;
    }
    // End Filters


    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
    const [selected_user_id, setSelectedUserId] = useState(false);
    const [modal_password, setModalPassword] = useState(false);
    const [modal_error, setModalError] = useState(false);
    const [modal_loading, setModalLoading] = useState(false);

    var admin = getUser()

    useEffect(() => {
        getUsersData();

        setFilterCourseValue(filter_course)
        setFilterTalentValue(filter_talent)
        setFilterGenderValue(filter_gender)
        setFilterBirthCountryValue(filter_birth_country)
        setFilterBirthCityValue(filter_birth_city)
        setFilterLivingCountryValue(filter_living_country)
        setFilterLivingCityValue(filter_living_city)
        setFilterFromYearValue(filter_from_year)
        setFilterFromMonthValue(filter_from_month)
        setFilterToYearValue(filter_to_year)
        setFilterToMonthValue(filter_to_month)
        setFilterSizeValue(filter_size)


    }, []);

    const openConfirmModal = (user_id) => {

        setSelectedUserId(user_id)
        setConfirmModalIsOpen(true)


    }
    const closeConfirmModal = () => {
        setConfirmModalIsOpen(false)

    }
    const handleChange = (e) => {
        switch (e.target.name) {
            case "modal_password":
                setModalPassword(e.target.value)
                break;

            default:
                break;
        }

    }

    const modalSubmit = () => {
        deleteThisUser()
    }

    const deleteThisUser = () => {
        setModalLoading(true)
        setModalError(false)
        if (!modal_password) {
            setModalError("Please Enter Password")
            return;
        }


        login({ email: admin.email, password: modal_password }).then((data) => {
            setModalLoading(false)
            if (data.tokens) {
                setLoading(selected_user_id);
                deleteUser(selected_user_id).then(data => {
                    //getUsersData();
                })
                window.location.href = "/cms/banned"
            }
            else {
                setModalError(data.detail);
            }

        });


    }

    const getUsersData = () => {
        filterBannedUsers(filter_query, page).then(data => {
            if (data && data.count) {

                setCount(data.count)
                var page_count = data.count % filter_size === 0 ? parseInt(data.count / filter_size) : parseInt(data.count / filter_size) + 1;
                var pages_array = range(1, page_count);
                setPages(pages_array);
            }
            if (data && data.results) {
                setUsers(data.results);
            }

        });
    }

    function range(start, end) {
        return Array.apply(0, Array(end))
            .map((element, index) => index + start);
    }

    const handleDelete = (id, e) => {
        setLoading(id);
        deleteUser(id).then(data => {
            getUsersData();
        })
    }
    const showFilters = (e) => {
        e.preventDefault();
        setShowFilter(!show_filter)
        filtered = false;
    }

    const showDelete = (e) => {
        e.preventDefault();
        setShowDelete(!show_delete)
    }







    const onValue = (value, name) => {
        // alert(name)
        switch (name) {
            case "course":
                setFilterCourseValue(value)
                break;
            case "talent":
                setFilterTalentValue(value)
                break;
            case "from_year":
                setFilterFromYearValue(value)
                break;
            case "from_month":
                setFilterFromMonthValue(value)
                break;
            case "to_year":
                setFilterToYearValue(value)
                break;
            case "to_month":
                setFilterToMonthValue(value)
                break;
            case "gender":
                setFilterGenderValue(value)
                break;
            case "size":
                setFilterSizeValue(value)
                break;
            case "country":
                setFilterBirthCountryValue(value)
                break;
            case "city":
                setFilterBirthCityValue(value)
                break;
            case "living_country":
                setFilterLivingCountryValue(value)
                break;
            case "living_city":
                setFilterLivingCityValue(value)
                break;
            default:
                break;
        }
    }




    return (
        <>
            <Modal
                closeTimeoutMS={500}
                isOpen={confirmModalIsOpen}
                onRequestClose={closeConfirmModal}
                className="Modal confirm-modal"
                overlayClassName="Overlay"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" onClick={closeConfirmModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title">Delete User</h4>
                    </div>
                    <div class="modal-body">
                        <div className="" style={{ minHeight: 100 }}>
                            <div className="col-md-12 mb-10 text-light">
                                To confirm Delete, Please enter your password
                            </div>
                            <div className="col-md-8">
                                <div class="input-group">
                                    <span class="input-group-addon"><i class="fa fa-lock"></i></span>
                                    <input type="password" className="form-control modal-password" onChange={handleChange} placeholder="Password" name="modal_password" />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <button className="btn btn-primary btn-rounded" onClick={modalSubmit}>DELETE</button>
                            </div>
                        </div>
                        {modal_error &&
                            <div className="alert alert-danger">
                                {modal_error}
                            </div>
                        }
                        {modal_loading &&
                            <div className="alert alert-primary text-color-light">
                                Please wait...
                            </div>
                        }
                    </div>

                </div>
            </Modal>
            <div className="content-wrapper">
                <section class="content-header">
                    <h3 class="box-title mt-5"></h3>
                    <ol class="breadcrumb">
                        <li><a href="/cms"><i class="fa fa-dashboard"></i> Home</a></li>
                        <li class="active">talents</li>
                    </ol>
                </section>

                <section className="content padding-top-sm-0">

                    <div className="row">
                        <div className="col-md-12">
                            {(show_filter || filtered) &&
                                <div class="box box-primary bg-f9">
                                    <form action="" className="form-horizontal">
                                        <div className="box-body padding-10">
                                            <div className="mb-10">
                                                <div className="col-md-7 padding-l-0 ">
                                                    <div className="col-md-6 padding-0 mb-10 padding-r-5">
                                                        <input type="text" name="first_name" defaultValue={filter_first_name} className="form-control" placeholder="First Name" />
                                                    </div>
                                                    <div className="col-md-6 mb-10  padding-0 ">
                                                        <input type="text" name="last_name" defaultValue={filter_last_name} className="form-control" placeholder="Last Name" />

                                                    </div>
                                                    <div className="col-md-12 padding-0">
                                                        <div className="pull-left margin-r-10 mb-10 padding-0">
                                                            <SelectGender value={filter_gender_value} width="130px" border="1" callback={onValue} />
                                                            <input type="hidden" name="gender" value={filter_gender_value} />
                                                        </div>
                                                        <div className="pull-left margin-r-10 mb-10 padding-0">
                                                            <SelectTalent value={filter_talent_value} width="180px" border="1" callback={onValue} />
                                                            <input type="hidden" name="talent" value={filter_talent_value} />
                                                        </div>
                                                        <div className="pull-left margin-r-10 mb-10 padding-0">
                                                            <SelectCourses value={filter_course_value} width="195px" border="1" callback={onValue} />
                                                            <input type="hidden" name="course" value={filter_course_value} />
                                                        </div>
                                                    </div>
                                                    <div className="clear"></div>
                                                </div>
                                                <div className="col-md-5  padding-10" style={{ backgroundColor: '#374355', color: 'white' }}>
                                                    <div className="row">
                                                        <label className="col-lg-12">Date of Birth</label>
                                                        <div className="col-lg-6 col-sm-12 padding-r-0 ">
                                                            <label className="col-lg-12 padding-0">From</label>
                                                            <div className="col-lg-12  padding-0">
                                                                <div className="pull-left">
                                                                    <SelectYear value={filter_from_year_value} name="from_year" width="80px" border="1" callback={onValue} />
                                                                    <input type="hidden" name="from_year" value={filter_from_year_value} />

                                                                </div>
                                                                <div className="pull-left margin-l-5">
                                                                    <SelectMonth value={filter_from_month_value} name="from_month" width="90px" border="1" callback={onValue} />
                                                                    <input type="hidden" name="from_month" value={filter_from_month_value} />
                                                                </div>
                                                            </div>
                                                            <div className="clear"></div>
                                                        </div>
                                                        <div className="col-lg-6  col-sm-12 padding-r-0">
                                                            <label className="col-lg-12 padding-0">To</label>
                                                            <div className="col-lg-12 padding-0">
                                                                <div className="pull-left">
                                                                    <SelectYear value={filter_to_year_value} name="to_year" width="80px" border="1" callback={onValue} />
                                                                    <input type="hidden" name="to_year" value={filter_to_year_value} />
                                                                </div>
                                                                <div className="pull-left margin-l-5">
                                                                    <SelectMonth value={filter_to_month_value} name="to_month" width="90px" border="1" callback={onValue} />
                                                                    <input type="hidden" name="to_month" value={filter_to_month_value} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="clear"></div>
                                            </div>
                                            <div className="">
                                                <div className="col-md-6  padding-10" style={{ backgroundColor: '#374355', color: 'white' }}>
                                                    <div className="col-md-12 padding-0">
                                                        <label>Born in</label>
                                                    </div>
                                                    <div className="pull-left margin-r-10 mb-10">
                                                        <SelectCountries kurds={1} value={filter_birth_country_value} name="country" width="220px" border="1" callback={onValue} />
                                                        <input type="hidden" name="country" value={filter_birth_country_value} />
                                                    </div>
                                                    <div className="pull-left ">
                                                        <SelectCities country={filter_birth_country_value} key={filter_birth_country_value} value={filter_birth_city_value} name="city" width="210px" border="1" callback={onValue} />
                                                        <input type="hidden" name="city" value={filter_birth_city_value} />
                                                    </div>
                                                    <div className="clear"></div>
                                                </div>
                                                <div className="col-md-6  padding-0 ">
                                                    <div className="padding-10 padding-l-5 " style={{ backgroundColor: '#374355', color: 'white' }}>
                                                        <div className="col-md-12 padding-0">
                                                            <label>Living in</label>
                                                        </div>
                                                        <div className="pull-left margin-r-10 mb-10 ">
                                                            <SelectCountries value={filter_living_country_value} name="living_country" width="210px" border="1" callback={onValue} />
                                                            <input type="hidden" name="living_country" value={filter_living_country_value} />
                                                        </div>
                                                        <div className="pull-left ">
                                                            <SelectCities country={filter_living_country_value} key={filter_living_country_value} value={filter_living_city_value} name="living_city" width="210px" border="1" callback={onValue} />
                                                            <input type="hidden" name="living_city" value={filter_living_city_value} />
                                                        </div>
                                                        <div className="clear"></div>
                                                    </div>
                                                    <div className="clear"></div>
                                                </div>
                                                <div className="clear"></div>
                                            </div>


                                        </div>
                                        <div className="box-footer bg-f9">
                                            <div className="pull-left ">
                                                <SelectSize value={filter_size_value} name="size" width="100px" border="1" callback={onValue} />
                                                <input type="hidden" name="size" value={filter_size_value} />
                                            </div>
                                            <button type="submit" className="btn btn-primary pull-right">Filter</button>
                                            <a href={`banned`} className="btn  pull-right mr-1 bg-white">Cancel</a>
                                        </div>
                                    </form>
                                </div>
                            }
                            <div class="box box-primary">
                                <div class="box-header with-border">
                                    <h3 class="box-title mt-5">Banned Talents    <small>({count && count})</small></h3>
                                    <a href="user" title="Filters" className="btn btn-info margin-r-5 pull-right " onClick={showFilters}><i className="fa fa-filter"></i></a>
                                    <a href="#" title="Show Delete Button" className="btn btn-danger margin-r-5 pull-right " onClick={showDelete}><i className="fa fa-trash"></i></a>
                                </div>
                                <div className="box-body no-padding">
                                    <table id="example1" className="table table-striped"> <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th className="hide-on-small" >Rating</th>
                                            <th >Talent</th>
                                            <th className="hide-on-small">Age</th>
                                            <th className="hide-on-small">Gender</th>
                                            <th className="hide-on-small">POB</th>
                                            <th className="hide-on-small">POR</th>
                                            <th style={{ width: 50 }}></th>
                                        </tr>
                                    </thead>
                                        <tbody>
                                            {users && users.map((item) => (
                                                <tr key={item.id} className={loading === item.id ? "loading" : ""}>
                                                    <td>
                                                        <div className="img-container ">
                                                            <a href={`usertalent/${item.id}`}  >
                                                                <img src={item.image ? item.image : "assets/dist/img/avatar5.png"} className="pull-left img-list margin-r-10" alt="" />
                                                            </a>
                                                        </div>

                                                        <a href={`usertalent/${item.id}`} className="link-color" >
                                                            {item.first_name &&
                                                                <p>{item.first_name} {item.last_name}</p>
                                                            }
                                                            {!item.first_name &&
                                                                <p>{item.email}</p>
                                                            }
                                                            <p title="Registered date" style={{ color: "#949090", fontSize: 11 }}>{item.created_at && item.created_at.split(' ')[0]}</p>
                                                        </a>

                                                    </td>
                                                    <td className="hide-on-small">
                                                        <span class="badge bg-red">55%</span>
                                                    </td>
                                                    <td>
                                                        <UserTalentList user_id={item.user} />
                                                    </td>
                                                    <td className="hide-on-small">
                                                        <td>{item.birth_date} <br />

                                                            <small>{getAge(item.birth_date)} Years old</small>
                                                        </td>
                                                    </td>
                                                    <td className="hide-on-small">{item.gender === 0 ? "Male" : item.gender === 1 ? "Female" : "Other"}</td>
                                                    <td className="hide-on-small"><CityName id={item.city_id} /></td>
                                                    <td className="hide-on-small"><CityName id={item.livingcity_id} /></td>
                                                    <td>
                                                        <div className="btn-group">
                                                            {show_delete &&
                                                                <button type="button" onClick={() => { openConfirmModal(item.user) }} className="btn btn-default btn-sm">
                                                                    <i className="fa fa-trash"></i>
                                                                </button>
                                                            }

                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th>Name</th>
                                                <th className="hide-on-small">Rating</th>
                                                <th >Talent</th>
                                                <th className="hide-on-small">Age</th>
                                                <th className="hide-on-small">Gender</th>
                                                <th className="hide-on-small">POB</th>
                                                <th className="hide-on-small">POR</th>
                                                <th></th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>

                            <ul className="pagination cms-pagination m-0 float-right">
                                <li className="page-item"><Link className="page-link" to="#">«</Link></li>
                                {pages && pages.map((page_number) => (
                                    <li className="page-item">
                                        <a className={page_number == page ? "page-link active" : "page-link"}
                                            href={`banned/${page_number}?${urlParams}`}>{page_number}</a>
                                    </li>
                                ))}
                                <li className="page-item"><Link className="page-link" to="">»</Link></li>
                            </ul>

                        </div>

                    </div>

                </section>



            </div>
        </>



    )
}
